import React from "react";
import { MdError } from "react-icons/md";

const ProfileError = ({ error, darkMode = true }) => {
  return (
    <div
      className={`w-full max-w-lg mx-auto px-8 py-5 rounded-2xl shadow-lg flex items-center space-x-4 ${
        darkMode
          ? "bg-gradient-to-r from-red-900/40 to-red-800/30 border border-red-700/50"
          : "bg-gradient-to-r from-red-100 to-red-50 border border-red-200"
      }`}
    >
      <MdError
        className={`flex-shrink-0 text-2xl ${
          darkMode ? "text-red-400" : "text-red-600"
        }`}
      />
      <div
        className={`text-lg font-bold ${
          darkMode ? "text-red-400" : "text-red-700"
        }`}
      >
        {error}
      </div>
    </div>
  );
};

export default ProfileError;
